import { apiFetch } from '@/api/client'

const ws = (workspaceId) => `workspaces/${workspaceId}`
const multipart = { 'Content-Type': 'multipart/form-data' }

export const workspacesApi = {
  list: (params, { signal } = {}) => apiFetch('workspaces', { params, signal }),
  get: (workspaceId) => apiFetch(ws(workspaceId)),
  // Multipart: the payload can carry the workspace logo file.
  create: (payload) => apiFetch('workspaces', { method: 'POST', body: payload, headers: multipart }),
  // Laravel method spoofing, kept as the backend expects it.
  update: (workspaceId, payload) =>
    apiFetch(ws(workspaceId), { method: 'POST', body: { ...payload, _method: 'PUT' }, headers: multipart }),
  updateStatus: (workspaceId, payload) => apiFetch(`${ws(workspaceId)}/status`, { method: 'PUT', body: payload }),
  updateDescription: (workspaceId, payload) =>
    apiFetch(`${ws(workspaceId)}/description`, { method: 'POST', body: { ...payload, _method: 'PUT' } }),
  remove: (workspaceId) => apiFetch(ws(workspaceId), { method: 'DELETE' }),
  join: (payload) => apiFetch('join-workspace', { method: 'POST', body: payload }),

  questionnaires: (workspaceId, params) => apiFetch(`${ws(workspaceId)}/questionnaires`, { params }),
  globalQuestionnaires: () => apiFetch('questionnaires/global'),
  questionnaireAiFill: (workspaceId) => apiFetch(`${ws(workspaceId)}/questionnaire-ai-fill`),
  dashboard: (workspaceId, params, { signal } = {}) =>
    apiFetch(`${ws(workspaceId)}/dashboard`, { params, signal }),
  activityLogs: (workspaceId, params, { signal } = {}) =>
    apiFetch(`${ws(workspaceId)}/activity-logs`, { params, signal }),
  stats: (params) => apiFetch('dashboard/workspace-stats', { params }),

  // Workspace members
  users: (workspaceId, params, { signal } = {}) => apiFetch(`${ws(workspaceId)}/users`, { params, signal }),
  user: (workspaceId, userId, { signal } = {}) => apiFetch(`${ws(workspaceId)}/users/${userId}`, { signal }),
  userHistory: (workspaceId, userId, params, { signal } = {}) =>
    apiFetch(`${ws(workspaceId)}/users/${userId}/history`, { params, signal }),
  createUser: (workspaceId, payload) =>
    apiFetch(`${ws(workspaceId)}/users`, { method: 'POST', body: payload }),
  updateUser: (workspaceId, userId, payload) =>
    apiFetch(`${ws(workspaceId)}/users/${userId}`, { method: 'PUT', body: payload }),
  bulkUpdateUserStatus: (workspaceId, payload) =>
    apiFetch(`${ws(workspaceId)}/users/bulk-update-status`, { method: 'POST', body: payload }),
  deleteUser: (workspaceId, userId) =>
    apiFetch(`${ws(workspaceId)}/users/${userId}`, { method: 'DELETE' }),
}
